import React,{useState,useEffect,useMemo} from 'react'
import {Link} from 'react-router-dom'
import {
	useDispatch,
	useSelector
} from 'react-redux'
import {
	selectAllTags
} from '../../state/accountTagsSlice'
import {
	setMode as setMessageCenterMode,
	setShow as setShowMessageCenter
} from '../MessageCenter/messageCenterSlice'
import {
	fullBasePath,
	capitalize,
	dateToYMD,
	slidingEditDistance
} from '../../util/util'
import {useClients} from '../users/hooks'
import {bulkTagClients} from '../users/usersSlice'
import { useDebounceCallback } from '@react-hook/debounce'
import { useInView } from 'react-intersection-observer'
import {selectTrainerParam,selectAllClients,getAllClients, showProspects, hideProspects} from '../users/usersSlice'
import useAccountTypeName from '../../hooks/useAccountTypeName'
import Button from "react-bootstrap/Button"
import Form from "react-bootstrap/Form"
import Dropdown from "react-bootstrap/Dropdown"
import OverlayTrigger from "react-bootstrap/OverlayTrigger"
import Popover from "react-bootstrap/Popover"
import Tooltip from "react-bootstrap/Tooltip"
import Spinner from "react-bootstrap/Spinner"
import Modal from "react-bootstrap/Modal"
import TagManager from '../TagManager/TagManager'
import ClientRow from '../ClientRow/ClientRow'
import Select from 'react-select'
import CenteredLoader from '../CenteredLoader/CenteredLoader';
import ExpandedData from "../ExpandedData/ExpandedData";
import ProspectViewer from '../ProspectViewer/ProspectViewer'
import styles from './ClientList.module.css'

const BulkTagModal = ({show,handleClose})=>{
	const dispatch = useDispatch()
	const [selectedTags,setSelectedTags] = useState([])
	const [selectedClients,setSelectedClients] = useState([])
	const tags = useSelector(selectAllTags)
	const clients = useSelector(selectAllClients)
	const [tagAllClients,setTagAllClients] = useState(false)
	const [isPending,setIsPending] = useState(false)
	const handleAssign = ()=>{
		setIsPending(true)
		dispatch(bulkTagClients({
			client_ids:selectedClients.map(c=>c.value),
			tag_ids:selectedTags.map(t=>t.value),
			tag_all_clients:Number(tagAllClients)
		})).then(()=>{
			setSelectedClients([])
			setSelectedTags([])
			setIsPending(false)
			setTagAllClients(false)
		})
	}

	return (
		<Modal show={show} onHide={handleClose}>
			<Modal.Header closeButton>
				<strong>Bulk Tag Clients</strong>
			</Modal.Header>
			<Modal.Body>
				<strong>Tags</strong>
				<Select
					onChange={setSelectedTags}
					value={selectedTags}
					options={tags.map(t=>({
						value:t.id,
						label:t.name
					}))}
					isMulti
				/>
				<strong>Clients</strong>
				<div className="d-flex">
					<div className="w-100 mr-1">
						<Select
							isDisabled={tagAllClients}
							onChange={setSelectedClients}
							value={tagAllClients?[]:selectedClients}
							options={tagAllClients?[]:clients.map(c=>({
								value:c.user_id_number,
								label:c.user_name
							}))}
							placeholder={tagAllClients?'Tagging All Clients':'Select...'}
							isMulti
						/>
					</div>
					<Button 
						onClick={()=>{
							setTagAllClients(p=>!p)
						}}
						variant={tagAllClients?"success":"outline-success"}
					>
						All
					</Button>
				</div>

				<Button 
					variant="outline-primary" 
					onClick={handleAssign}
					disabled={isPending||(!tagAllClients&&!selectedClients.length)||!selectedTags.length}
					className="mt-2"
					size="sm" 
					block
				>
					Add Tag(s) to Client(s) {isPending&&<Spinner animation="border" size="sm"/>}
				</Button>
			</Modal.Body>
		</Modal>
	)
}

const TagsLegend = ({activeTags,onTagClick,setTagFilters}) => {
	const tags = useSelector(selectAllTags)
	const [showTagManger,setShowTagManger] = useState(false)
	const clientAccountName = useAccountTypeName('client')
	const clients = useSelector(selectAllClients)
	return (
		<div className="mb-2">
			<div className="w-100 d-flex flex-wrap">
			{clients.length>0 ?
			<OverlayTrigger overlay={
				<Tooltip>
					Manage Tags
				</Tooltip>
			}>
				<button 
					style={{background:'none',border:'none'}} 
					className="text-primary"
					onClick={()=>setShowTagManger(true)}
				>
					<i className="fa fa-cog mr-1"/>
					{tags.length === 0 && `Manage tags that you can use to filter ${clientAccountName}s`}
				</button>
			</OverlayTrigger>

				:null}
				{tags.map(tag=>(
					<div 
						style={{
							cursor:'pointer',
							border:`1px solid ${activeTags.has(tag.name)?'blue':'transparent'}`
						}}
						className="m-1 px-2 rounded"
						onClick={()=>onTagClick(tag.name)}>
						<span 
							style={{
								display:'inline-block',
								background:tag.color,
								width:'10px',
								height:'10px',
								borderRadius:'100%',
								marginRight:'4px'
							}}
						/>
						{tag.name}
					</div>
				))}
			</div>
			<TagManager setTagFilters={setTagFilters} show={showTagManger} onHide={()=>setShowTagManger(false)}/>
		</div>
	)
}

const queryMatches = (string,query)=>(
	string.toLowerCase().indexOf(query.toLowerCase()) > -1
)

const getCompliancePercent = (event, data) => {
  const eventTotal =
    event !== "simplified_nutrition"
      ? parseInt(data.complete) + parseInt(data.notMet)
      : parseInt(data.assigned);
  if (!eventTotal) return "NO_DATA";
  const completed =
    event !== "simplified_nutrition"
      ? parseInt(data.complete)
      : parseInt(data.completed);
  return (completed / eventTotal)*100;
};

const passesComplianceFilters = (compliance,event,comparison,filterPercentMin,filterPercentMax)=>{
	const eventData = compliance[event]
	const actualPercent = getCompliancePercent(event, eventData);
	if (actualPercent === "NO_DATA") return false;
	/*
		lt = less than 
		gt = greater than
		bt = between
	*/
	if (comparison === "lt") {
		return actualPercent <= filterPercentMax;
	} else if (comparison === "gt") {
		return actualPercent >= filterPercentMin;
	} else if (comparison === "bt") {
		return (
			filterPercentMin <= actualPercent &&
			actualPercent <= filterPercentMax
		)
	}
}

const passesTagFilters = (tags,tagFilters)=>(
	Array.from(tagFilters).reduce(
		(carry,filter)=>carry&&tags.map(tag=>tag.name).includes(filter),
		true
	)
)

const ClientList = props =>{
	const dispatch = useDispatch()
	const [loadingSpinner, setLoadingSpinner]=useState(false)
	
	useEffect(()=>{
		setLoadingSpinner(true)
		dispatch(getAllClients({include_compliance:1})).then(() => {
			setLoadingSpinner(false)
		})
	},[])

	const baseUrl = fullBasePath()
	const trainerParam = useSelector(selectTrainerParam)
	//state for filtering
	const [searchQuery,setSearchQuery] = useState('')
	const [showFilterPopover, setShowFilterPopover] = useState(false);
	const [dataToDisplay, setDataToDisplay] = useState("all");
	const [isComplianceFiltered, setIsComplianceFiltered] = useState(false);
	const [filterEvent, setFilterEvent] = useState("workout");
	const [resultText, setResultText] = useState("");
	const [filterComparison, setFilterComparison] = useState("lt");
	const [filterPercentMax, setFilterPercentMax] = useState("");
	const [filterPercentMin, setFilterPercentMin] = useState("");
	const [tagFilters,setTagFilters] = useState(new Set([]))
	const [showBulkTagModal,setShowBulkTagModal] = useState(false)
	const [sortByLastName,setSortByLastName] = useState(false)

	const clients = useSelector(selectAllClients).filter(client => {
		let showClient = true
		//filter by compliance
		if(isComplianceFiltered){
			const complainceFiltersPassed = passesComplianceFilters(
				client.compliance,
				filterEvent,
				filterComparison,
				filterPercentMin,
				filterPercentMax
			)
			showClient = showClient && complainceFiltersPassed
		}
		//check if tag filters are passed
		showClient = showClient && passesTagFilters(client.tags,tagFilters)
		return showClient
	})

	const clientsSorted = useMemo(
		() => clients.sort((a,b)=>{
			const aName = (
				sortByLastName
				? a.user_name.split(' ').pop()
				: a.user_name
			)
			const bName = (
				sortByLastName
				? b.user_name.split(' ').pop()
				: b.user_name
			)

			const {dist:aDist,offset:aOffset} = slidingEditDistance(aName,searchQuery)
			const {dist:bDist,offset:bOffset} = slidingEditDistance(bName,searchQuery)
			const alphabetical = aName < bName ? -1 : 1
			//primary sort using distances else secondary sort using offset 
			return aDist - bDist || aOffset - bOffset || alphabetical
		}),
		[clients,searchQuery,sortByLastName]
	)

	const clientsAll = useSelector(selectAllClients);

	const clientBlockSize = 50
	const [displayCount, setDisplayCount] = useState(clientBlockSize)
	window.setDisplayCount = setDisplayCount

	const clientsDisplayList = useMemo(
		() => clientsSorted.slice(0, displayCount),
		[clientsSorted, displayCount,sortByLastName]
	)

	//reset the display count everytime the fitlers or search query or list have changed
	useEffect(() => {
		setDisplayCount(clientBlockSize)
	}, [searchQuery,filterEvent,filterComparison,filterPercentMin,filterPercentMax,tagFilters])

	const { ref: scrollRef, inView } = useInView({
		/* Optional options */
		threshold: 0,
	});

	useEffect(() => {
		if (inView && displayCount < clientsAll.length) {
			setDisplayCount(displayCount + clientBlockSize)
		}
	}, [inView])

	const user = useSelector((state) => state.users.current_user);
	const isOwner = (
		parseInt(user.gym_id) !== 0 
		? user.account_type === 'gym'
		: user.account_type === 'trainer'
	)

	const filterEventOptions = {
		workout: "Workouts",
		task: "Tasks",
		nutrition: "Nutrition",
		simplified_nutrition: user?.isMAXUser ? "MAX Nutrition" : "Simplified Nutrition",
	};
	const dataDisplayOptions = {
		all: "All Data",
		...filterEventOptions,
	};
	const comparisonOptions = {
		lt: "less than",
		bt: "between",
		gt: "greater than",
	}
	const clearFilters = () => {
		setIsComplianceFiltered(false);
	};

	const prospects = useSelector(state => state.users.prospects)
	function toggleProspectsHandler() {
		if (!prospects.show) {
			dispatch(showProspects())
		} else {
			dispatch(hideProspects())
		}
	} 

	const clientAccountName = useAccountTypeName('client')
	const filterPopover = (
		<Popover>
			<Popover.Content>
				<div className="text-center mb-1">Filter By</div>
				<Form.Control
					className="mb-1"
					as="select"
					onChange={() => {
						const val = window.event.target.value;
						setFilterEvent(val);
					}}
					custom
				>
					{Object.keys(filterEventOptions).map((k) => (
						<option value={k} selected={k === filterEvent}>
							{filterEventOptions[k]}
						</option>
					))}
				</Form.Control>
				<div className="text-center mb-1">
					with compliance
					<OverlayTrigger
						overlay={
						<Tooltip style={{ fontSize: "12px" }}>
							<div>compliance =</div>
							<div style={{ whiteSpace: "nowrap" }}>
								complete/(complete + not met)
							</div>
						</Tooltip>
						}
					>
						<i className="fa fa-info-circle ml-1" />
					</OverlayTrigger>
				</div>
				<Form.Control
					className="mb-1"
					as="select"
					onChange={(e) => {
						setFilterComparison(e.target.value);
					}}
				>
					{Object.keys(comparisonOptions).map((k) => (
						<option value={k} selected={k === filterComparison}>
							{comparisonOptions[k]}
						</option>
					))}
				</Form.Control>
				{["bt", "gt"].includes(filterComparison) ? (
					<input
						className="form-control mb-1"
						value={filterPercentMin}
						onInput={() => setFilterPercentMin(window.event.target.value)}
						placeholder="percent (eg 10)"
					/>
				) : null}
				{["bt", "lt"].includes(filterComparison) ? (
					<input
						className="form-control mb-1"
						value={filterPercentMax}
						onInput={() => setFilterPercentMax(window.event.target.value)}
						placeholder="percent (eg 75)"
					/>
				) : null}

				<div className="d-flex justify-content-between">
				<Button size="sm" variant="outline-danger" onClick={clearFilters}>
					Clear
				</Button>
				<Button
					size="sm"
					variant="outline-primary"
					onClick={() => {
						//if filtered data is not visible make it visible
						if (dataToDisplay !== "all" && dataToDisplay !== filterEvent) {
							setDataToDisplay(filterEvent);
						}
						setIsComplianceFiltered(true)
					}}
				>
					apply
				</Button>
			</div>
			</Popover.Content>
		</Popover>
	);

	useEffect(()=>{
		setResultText(`
			Showing ${clientAccountName}s that have ${filterEventOptions[filterEvent]} with compliance 
			${comparisonOptions[filterComparison]}
			${["bt", "gt"].includes(filterComparison) ? ` ${filterPercentMin} ` : ""}
			${filterComparison === "bt" ? " & " : ""}
			${["lt", "bt"].includes(filterComparison) ? ` ${filterPercentMax}` : ""}
		`)
	},[filterEvent,filterComparison,filterPercentMin,filterPercentMax])

	const tagClickHandler = tagName => {
		const update = new Set(tagFilters)
		if(tagFilters.has(tagName)){
			update.delete(tagName)
		}else{
			update.add(tagName)
		}
		setTagFilters(update)
	}

	const [includeFuture,setIncludeFuture] = useState(!user?.isMAXUser)
	const handleToggleFutureEventCompliance = (e) => {
		setLoadingSpinner(true)
		const payload = (
			e.target.checked 
			? {to_date:'9999-12-31',refresh_compliance:1} 
			: {to_date:dateToYMD(new Date()),refresh_compliance:1}
		)
		dispatch(getAllClients(payload)).then(()=>{
			setLoadingSpinner(false)
		})
		setIncludeFuture(e.target.checked)
	}

	const handleRefreshCompliance = ()=>{
		setLoadingSpinner(true)
		const payload = (
			includeFuture 
			? {to_date:'9999-12-31',refresh_compliance:1} 
			: {to_date:dateToYMD(new Date()),refresh_compliance:1}
		)
		dispatch(getAllClients(payload)).then(()=>{
			setLoadingSpinner(false)
		})
	}

	const debouncedClientSearch = useDebounceCallback(
		setSearchQuery,
		300
	)

	return (
		<div className={styles.clientListContainer} style={{ flex: "1 1 auto",  }} id="containerDiv">
			<div className="mb-2 w-100 p-2 p-md-3">
				<div className="d-flex flex-wrap align-items-center mb-1">
					<strong className="mr-2">Clients:</strong>
					<div style={{flex:'1 1 auto'}}>
						<Button
							to={`/add-client?${trainerParam}`}
							as={Link}
							variant="outline-success"
							size="sm"
							className="mr-2 my-1"
						>
							<i className="fas fa-plus"></i> Add {capitalize(clientAccountName)}
						</Button>
						<Button
							onClick={()=>{
								dispatch(setMessageCenterMode('GROUP'))
								dispatch(setShowMessageCenter(true))
							}}
							variant="outline-primary"
							size="sm"
							className="mr-2 my-1"
						>
							<i className="fas fa-paper-plane"></i> Group Messenger
						</Button>
						<OverlayTrigger overlay={
							<Tooltip>Add multiple tags to multiple clients at once</Tooltip>
						}>
							<Button 
								onClick={()=>{
									setShowBulkTagModal(true)
								}}
								variant="outline-info"
								size="sm"
								className="mr-2 my-1"
							>
								Bulk Tag Clients
							</Button>
						</OverlayTrigger>
						{isOwner&&
							<Button
								as={Link}
								to="/growth"
								variant="outline-info"
								size="sm"
								className="mr-2 my-1"
							>
								<i className="far fa-user"></i> Prospective {capitalize(clientAccountName)}s
							</Button>
						}
						<Dropdown className="d-inline-block mr-2 my-1">
							<Dropdown.Toggle size="sm" variant="outline-secondary">
								Quick Links
							</Dropdown.Toggle>

							<Dropdown.Menu>
								<Dropdown.Header>All</Dropdown.Header>
								<Dropdown.Item
									as={Link}
									to={`/eventsView/?display=all&selector=Workouts&filter=all&view=list&${trainerParam}`}
								>
									Workouts
								</Dropdown.Item>
								<Dropdown.Item
									as={Link}
									to={`/eventsView/?display=all&selector=Tasks&filter=all&view=list&${trainerParam}`}
								>
									Tasks
								</Dropdown.Item>
								<Dropdown.Item
									as={Link}
									to={`/eventsView/?display=all&selector=Nutrition&filter=all&view=list&${trainerParam}`}
								>
									Nutrition
								</Dropdown.Item>
								<Dropdown.Divider />
								<Dropdown.Header>Favorites</Dropdown.Header>
								<Dropdown.Item
									as={Link}
									to={`/eventsView/?display=all&selector=Workouts&filter=favorite&view=list${trainerParam}`}
								>
									Workouts
								</Dropdown.Item>
								<Dropdown.Item
									as={Link}
									to={`/eventsView/?display=all&selector=Tasks&filter=favorite&view=list${trainerParam}`}
								>
									Tasks
								</Dropdown.Item>
								<Dropdown.Item
									as={Link}
									to={`/eventsView/?display=all&selector=Nutrition&filter=favorite&view=list${trainerParam}`}
								>
									Nutrition
								</Dropdown.Item>
							</Dropdown.Menu>
						</Dropdown>
					</div>
				</div>
				{ (clientsAll.length > 0 || loadingSpinner) && <><div className="d-flex mb-1">
					<Form.Control
						onChange={e=>debouncedClientSearch(e.target.value)}
						placeholder={`Search ${capitalize(clientAccountName)}s`}
					/>
					<div className="d-flex justify-content-between align-items-center ml-2">
						<Form.Control
							className="mr-1"
							as="select"
							onChange={() => setDataToDisplay(window.event.target.value)}
						>
							{Object.keys(dataDisplayOptions).map((k) => (
								<option value={k} selected={k === dataToDisplay}>
								{dataDisplayOptions[k]}
								</option>
							))}
						</Form.Control>
						<OverlayTrigger
							trigger="click"
							show={showFilterPopover}
							onHide={() => setShowFilterPopover(false)}
							placement="left"
							overlay={filterPopover}
						>
							<OverlayTrigger overlay={
								<Tooltip>
									Client Filter
								</Tooltip>
							}>
								<Button
								onClick={() => setShowFilterPopover(!showFilterPopover)}
								size="sm"
								variant={showFilterPopover ? "outline-danger" : "outline-primary"}
								>
									<i className={showFilterPopover ? "fas fa-times-circle" : "fas fa-filter"}/>
								</Button>
								</OverlayTrigger>
						</OverlayTrigger>
					</div>
				</div>
				{isComplianceFiltered ? (
					<div className="border my-1 py-1 px-3 rounded">
						{resultText}
						<span
							style={{ cursor: "pointer" }}
							className="text-danger m-1"
							onClick={clearFilters}
						>
							remove this filter
						</span>
					</div>
				) : null}
					<TagsLegend activeTags={tagFilters} onTagClick={tagClickHandler} setTagFilters={setTagFilters}/>
				<div className="d-flex align-items-center mb-1 flex-wrap">
					<Form.Switch 
						className="mr-2"
						checked={sortByLastName}
						onChange={e=>{
							setSortByLastName(e.target.checked)
						}}
						label="Sort by last name"
						id="sort-by-last-name-switch" 
					/>
					<Form.Switch 
						checked={includeFuture}
						onChange={handleToggleFutureEventCompliance}
						label="Include future events in compliance"
						id="future-compliance=toggle" 
					/>
					<OverlayTrigger overlay={
						<Tooltip>When disabled only past events will be used to calculate compliance</Tooltip>
					}>
						<i className="fas fa-info-circle ml-1 text-info"/>
					</OverlayTrigger>
					<OverlayTrigger rootClose overlay={
						<Tooltip>Compliance data can only be refreshed manually.</Tooltip>
					}>
						<Button
							onClick={handleRefreshCompliance}
							disabled={loadingSpinner}
							variant="outline-dark"
							className="ml-auto"
							size="sm">
							Refresh Compliance Data
						</Button>
					</OverlayTrigger>
				</div></>}
			</div>
			<div className="d-flex position-relative align-items-stretch" >
				{
					loadingSpinner ?
					<div style={{
						display:'flex',
						justifyContent:'center',
						alignItems:"center",
						position:'absolute',
						width:'100%',
						background:'rgba(0,0,60,0.2)',
						height:'100%',
						padding:'32px',
						zIndex:'20'
					}}>
						<div  style={{width:'25px', height:'25px'}}>
							<Spinner animation="border" variant="white"/>
						</div>
					</div>
					: 
					null
				}
				<table style={loadingSpinner ? {minHeight:"50px"} : {}} className="w-100 border rounded bg-white" >
					<tbody>
						{clientsDisplayList.length > 0 && clientsDisplayList.map(client=>(
							<ClientRow 
								openExandedDataHandler={props.openExandedDataHandler}
								openChatHandler={props.openChatHandler} 
								dataToDisplay={dataToDisplay} 
								clientId={client.user_id_number}/>
						)) }
					</tbody>
				</table>
			</div>
			{displayCount <= clients.length &&
				<div ref={scrollRef}>
					Loading more...
				</div>
			}
			{clients.length > 0 &&
				<div className="mt-1">
					<i className="fas fa-info-circle"></i> Click on the
					progress bars to see expanded data
				</div>
			}
			{clients.length ===0 && tagFilters.size > 0 ? <h4 style={{marginTop:'20px'}}>No clients with the selected tag{tagFilters.size===1 ? '': 's'}</h4> : null}
			<ExpandedData/>
			<ProspectViewer/>
			<BulkTagModal
				handleClose={()=>{
					setShowBulkTagModal(false)
				}}
				show={showBulkTagModal}
			/>
		</div>
		
	)
}

export default ClientList